import ErrorContainer from "../../components/utils/ErrorContainer";
import { useOnClickOutside } from "../../hooks";
import { fetchGoods, getRecipeById, setActiveModalAction } from "../../action";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fromStore, modalsSelector } from "../../selectors";
import Select from "react-select";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ru from "date-fns/locale/ru";
import cn from "classnames";
import { fetchRawsList } from "../../action/raw";
import { createReceipe, updateReceipe } from "../../action/recipes";
import { isEmpty } from "lodash";
import { MEASURES_RAW } from "../rawmaterials/constansts";
import swal from 'sweetalert';
import { parseNumToFixed } from "../../utils/common";
registerLocale("ru", ru);

const colourStyles = {
    control: (styles) => ({
        ...styles,
        border: "1px solid #e2e5ec",
        boxShadow: "none",
    }),
    option: (styles, {isFocused, isSelected}) => ({
        ...styles,
        backgroundColor: isFocused ? "#f0f0f0" : isSelected ? "#e2e5ec" : null,
        color: "#333",
    }),
};

export function ReceipeModal() {
    const ref = useRef();
    const dispatch = useDispatch();
    const loaderModal = useSelector(fromStore.loaderModalRecipeSelector);
    const loaderList = useSelector(fromStore.loaderRawsSelector);
    const loaderListGood = useSelector(fromStore.loaderGoodsSelector);
    const loading = loaderModal || loaderList || loaderListGood;
    const raws = useSelector(fromStore.rawListSelector);
    const goods = useSelector(fromStore.goodListSelector);
    const receipeData = useSelector(modalsSelector).recipes;
    const detail = useSelector(receipeData.type === 'semi' ? fromStore.detailRawSelector : fromStore.detailGoodSelector);

    const recipeLoaded = detail && detail.recipes;

    const initData = (receipeData && receipeData.data) ? {
        productId: detail.id,
        type: receipeData.type,
        startDate: new Date(),
        ingredients: [],
    } : {
        productId: detail.id,
        type: receipeData.type,
        startDate: new Date(),
        ingredients: [],
    };

    const [data, setData] = useState(initData);

    useEffect(() => {
        if (isEmpty(raws)) dispatch(fetchRawsList());
        if (isEmpty(goods) && receipeData.type === 'good') dispatch(fetchGoods());
        if (detail.id && !recipeLoaded) dispatch(getRecipeById(detail.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, raws, goods, receipeData]);

    useEffect(() => {
        if (receipeData && receipeData.data) setData(receipeData.data);
    }, [dispatch, receipeData]);

    useEffect(() => {
        if (detail && detail.id && (!receipeData || !receipeData.data) && recipeLoaded && recipeLoaded.length > 2) swal({
            title: 'Создание нового рецепта невозможно',
            text: 'Ограничение кол-ва рецептов - 3. Чтобы создать новый рецепт - удалите старый.',
            icon: "error",
            dangerMode: true,
            button: "Ок",
        }).then(() => {
            onClose();
            return;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detail, receipeData, recipeLoaded])

    const renderName = (item, type) => {
        let categoryText;
        let typeText;

        if (type === 'good') {
            typeText = '(товар)';
            categoryText = (item.category && item.category.title) ? item.category.title : null;
        } else {
            if (type === 'raw') {
                typeText = '(сырье)';
            } else {
                typeText = '(п/ф)';
            }
            categoryText = (item.productscategory && item.productscategory.title) ? item.productscategory.title : null;
        }

        return categoryText ? `${categoryText}: ${item.name || `Наименование продукта id ${item.id} не определено`} ${typeText}` : `${item.name || `Наименование продукта id ${item.id} не определено`} ${typeText}`
    }

    const getIngredients = (ingredients) => {
        if (!ingredients) return [];

        const getIngredientName = (good, modId, type) => {
            if (isEmpty(good.modifications)) return renderName(good, type);

            let mod = null;
            if (modId) {
                mod = good.modifications.find((item) => item.id === modId);
            } else {
                mod = good.modifications.find((item) => item.default);
            }
            
            if (!mod) return renderName(good, type);
            return `${renderName(good, type)} ${mod.title || `Наименование модификации id ${modId} не определено`}`
        }

        const result = ingredients.map((ingredient) => {
            let entity = null;
            const partsId = typeof ingredient.id === 'string' ? ingredient.id.split('_') : null;
            const ingredientId = (partsId && partsId[0]) ? parseInt(partsId[0]) : ingredient.id;
            const modId = (partsId && partsId[1]) ? parseInt(partsId[1]) : null;

            if (ingredient.type === 'good') {
                entity = goods.find((good) => good.id === ingredientId);
                entity.measure = 'pc';
            } else {
                entity = raws.find((raw) => raw.id === ingredientId);
            }

            const name = getIngredientName(entity, modId, ingredient.type)
            return { ...ingredient, name, measure: entity.measure };
        });
        return result;
    }

    const getOptionsIngredients = () => {
        let arr = (raws || []).map((raw) => ({ ...raw, type: raw.productscategory.type }));
        if (receipeData.type === 'good') arr = [...arr, ...(goods || []).map((good) => ({ ...good, type: 'good' }))];
        
        const result = arr.filter((ingredient) => {
            if (receipeData.type !== ingredient.type) return true;
            if (ingredient.id === detail.id) return false;
            return true;
        }).flatMap((item) => {
            if (isEmpty(item.modifications)) {
                return ([{
                    value: item.id,
                    label: renderName(item, item.type),
                    type: item.type,
                    measure: item.measure,
                }])
            }

            return item.modifications.map((mod) => {
                const resultId = mod.default ? item.id : `${item.id}_${mod.id}`;
                return ({
                    value: resultId,
                    label: `${renderName(item, 'good')} ${mod.title || `Наименование модификации id ${mod.id} не определено`}`,
                    type: item.type,
                    measure: item.measure,
                })
            })
        });
        return result;
    }

    const handleIngredientChange = (selectedOptions) => {
        const updated = {...data};

        const prevIngredients = updated.ingredients.filter((ingredient) =>( selectedOptions || []).some((item) => item.value === ingredient.id))
        
        const newIngredients = selectedOptions ? selectedOptions.filter((option) => !updated.ingredients.some((item) => item.id === option.value))
        .map((option) => ({
            id: option.value,
            quantity: {},
            type: option.type,
        })) : [];

        updated.ingredients = [...prevIngredients, ...newIngredients];
        setData(updated);
    };

    const handleQuantityChange = (index, value, field) => {
        const updated = {...data};
        updated.ingredients[index].quantity[field] = value;
        setData(updated);
    };

    const changeDate = (date) => {
        const updated = {...data};
        updated.startDate = date;
        setData(updated);
    }

    const handleSubmit = async (e) => {
        const getQuantitySum = (quantity) => {
            if (!quantity || quantity.length === 0) return 0;
            const sum = Object.values(quantity).reduce((acc, value) => acc + value, 0);
            return sum;
        }
        e.preventDefault();
        const sended = { ...data };
        sended.ingredients = await sended.ingredients.filter((ingredient) => getQuantitySum(ingredient.quantity) > 0);
        if (!isValid(sended)) {
            setData(sended);
            return;
        }
        let result = null;
        if (receipeData && receipeData.data && receipeData.action !== 'copy') {
            result = await dispatch(updateReceipe(sended));
        } else {
            result = await dispatch(createReceipe(sended));
        }
        if (result) onClose();
    };

    const onClose = () => !loading && dispatch(setActiveModalAction({ field: "recipes", value: null }));
    useOnClickOutside(ref, onClose);

    const isValid = (values) => {
        const validation = values ? values : data;
        if (loading) return false;
        if (!validation || !validation.ingredients || validation.ingredients.length <= 0) return false;
        return true;
    }

    const renderModifications = (modifications) => {
        if (!modifications || modifications.length === 0) return;
        const mods = modifications.filter((mod) => !mod.default);
        if (!mods || mods.length === 0) return;

        return mods.map((mod) => {
            return(
                <div className="form-group" key={`mod${mod.id}`}>
                    <div className="kt-separator kt-separator--border-dashed kt-separator--space-sm"></div>
                    <h4 style={{ color: "black" }}>Модификация {mod.title || ''}</h4>
                    <div className="row mb-3">
                        {getIngredients(ingredients).map((ingredient, index) => (
                            <React.Fragment key={`mod${mod.id}_${ingredient.type}_${ingredient.id}`}>
                                <div className="col-7 mb-2">
                                    <label className="col-form-label">
                                        {ingredient.name}
                                    </label>
                                </div>
                                <div className="col-4 mb-2">
                                    <input
                                        type="number"
                                        className="form-control"
                                        min="0"
                                        step="0.0001"
                                        value={parseNumToFixed(ingredient.quantity[mod.id], 3) || 0}
                                        onFocus={(e) => e.target.select()}
                                        onChange={(e) => {
                                            if (!isNaN(e.target.value) && e.target.value >= 0) {
                                                handleQuantityChange(index, parseNumToFixed(parseFloat(e.target.value), 3), mod.id);
                                            } else {
                                                handleQuantityChange(index, 0, mod.id);
                                            }
                                        }}
                                        required
                                        style={{ textAlign: 'center' }}
                                    />
                                </div>
                                <div className="col-1 mb-2">
                                    <label className="col-form-label">
                                        {MEASURES_RAW[ingredient.measure] || ''}
                                    </label>
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            )
        });            
    }

    const ingredients = (data && data.ingredients && data.ingredients.length > 0) ? data.ingredients : []

    return (
        <form onSubmit={handleSubmit}>
            <div className="modal fade show" style={{ display: "block" }}>
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content" ref={ref}>
                        <div className="modal-header">
                            <h5 className="modal-title">Новый рецепт товара</h5>
                            <button onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <div className="row mb-3">
                                    <div className="col-2">
                                        <label className="col-form-label">Период с:</label>
                                    </div>
                                    <div className="col-10">
                                        <DatePicker
                                            selected={new Date(data.startDate)}
                                            className="form-control"
                                            onChange={(date) => changeDate(date)}
                                            showTimeSelect
                                            timeFormat="HH:mm:ss"
                                            timeIntervals={1}
                                            dateFormat="dd.MM.yyyy HH:mm:ss"
                                            locale="ru"
                                            onKeyDown={(e) => e.preventDefault()}
                                            minDate={new Date()}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="g-priority" className="form-control-label">
                                    Добавить ингредиенты
                                </label>
                                <div className="row">
                                    <div className="col-12">
                                        <Select
                                            isMulti
                                            isLoading={loading}
                                            isDisabled={loading}
                                            placeholder="Выберите ингредиенты..."
                                            options={getOptionsIngredients()}
                                            styles={colourStyles}
                                            onChange={handleIngredientChange}
                                            value={getIngredients(ingredients).map((raw) => ({
                                                value: raw.id,
                                                label: raw.name,
                                                type: raw.type,
                                                measure: raw.measure,
                                            }))}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                {detail && !isEmpty(detail.modifications) && <h4 style={{ color: "black" }}>По умолчанию</h4>}
                                <div className="row mb-3">
                                    {getIngredients(ingredients).map((ingredient, index) => (
                                        <React.Fragment key={`${ingredient.type}_${ingredient.id}`}>
                                            <div className="col-7 mb-2">
                                                <label className="col-form-label">
                                                    {ingredient.name}
                                                </label>
                                            </div>
                                            <div className="col-4 mb-2">
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    onFocus={(e) => e.target.select()}
                                                    min="0"
                                                    step="0.0001"
                                                    value={parseNumToFixed(ingredient.quantity.default, 3) || 0}
                                                    onChange={(e) => {
                                                        if (!isNaN(e.target.value) && e.target.value >= 0) {
                                                            handleQuantityChange(index, parseNumToFixed(parseFloat(e.target.value), 3), 'default');
                                                        } else {
                                                            handleQuantityChange(index, 0, 'default');
                                                        }
                                                    }}
                                                    required
                                                    style={{ textAlign: 'center' }}
                                                />
                                            </div>
                                            <div className="col-1 mb-2">
                                                <label className="col-form-label">
                                                    {MEASURES_RAW[ingredient.measure] || ''}
                                                </label>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>

                            {renderModifications(detail.modifications)}

                            <ErrorContainer field="modalRecipe" hasCloseButton={true}/>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
                                    Отмена
                                </button>
                                <button
                                    onClick={handleSubmit}
                                    type="submit"
                                    className={cn({
                                        'btn btn-primary kt-spinner--right kt-spinner--sm kt-spinner--light': true,
                                        'kt-spinner': loading
                                    })}
                                    disabled={!isValid(null)}
                                >
                                    Сохранить
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
}
